var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.4399 0.560547V12.9205C20.4399 17.6405 19.5999 21.8806 17.9199 25.6405C16.3199 29.4005 13.5599 33.2805 9.63988 37.2805L2.55988 31.6405C6.55988 27.5605 8.99988 23.6405 9.87988 19.8806H0.879883V0.560547H20.4399ZM45.5199 0.560547V12.9205C45.5199 17.6405 44.6799 21.8806 42.9999 25.6405C41.3999 29.4005 38.6399 33.2805 34.7199 37.2805L27.6399 31.6405C31.6399 27.5605 34.0799 23.6405 34.9599 19.8806H25.9599V0.560547H45.5199Z","fill":"#E6E6EC"}));
}

Quote.defaultProps = {"width":"46","height":"38","viewBox":"0 0 46 38","fill":"none"};

module.exports = Quote;

Quote.default = Quote;
